import { trigger, style, transition, animate, state } from '@angular/animations';

export const slideIn = trigger('slideIn', [
    state('false', style({ transform: 'translateY(-180%)' })),
    state('true', style({ transform: 'translateY(30%)' })),
    transition("1 => 0", animate('700ms ease-in-out')),
    transition("0 => 1", animate('700ms ease-in-out'))
]);